import { Component, OnInit } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-help',
	templateUrl: './help.component.html',
	styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

	constructor(
		public locale: LocaleService
	) { }

	ngOnInit(): void {
	}

}
